import z from "zod"

import { queryClient } from "~/backend/queryClient"
import { findOperationChainsQueryKey, useCreateOperationChain } from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

const operationChainTypes = ["PRODUCT", "COMPONENT", "MATERIAL"] as const

export type OperationChainType = (typeof operationChainTypes)[number]

export const OperationChainType = {
  PRODUCT: "PRODUCT",
  COMPONENT: "COMPONENT",
  MATERIAL: "MATERIAL",
} as const

export type CreateOpChainDto = {
  name: string
  type: OperationChainType
}

export const createOpChainSchema = z.strictObject({
  name: z.string().min(1),
  type: z.enum(operationChainTypes),
})

export const useCreateOpChainMutation = () =>
  useCreateOperationChain({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: findOperationChainsQueryKey(),
        })
        showSuccessNotification({
          title: "Success",
          message: "Operation chain created",
        })
      },
      onError: (error) => {
        showAxiosError({
          notificationTitle: "Error",
          notificationMessage: "Failed to create operation chain",
          showNotification: true,
          error,
        })
      },
    },
  })
